import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
import { bgVendorEditPath, bgVendorDetailPath } from 'routes'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { BGListContainer } from './styled'
import { getBankGuarantees } from 'ducks/bankGuarantee'
import { getVendors, getCompanies } from 'ducks/options'
import { columns } from '../../AttributeData'
import { MainBodyContent, CustomButton, TablePagination } from 'components'
import SearchList from '../../Form/SearchList'
import CreateBankGuaranteeModal from './Form/CreateModal'

const PurchaseRequisition = (props) => {
  const { listBG, valueForm, vendorOptions, companyOptions, user } = props
  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = useState(userPageSize)
  const [showCreateModal, setShowCreateModal] = useState(false)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.getBankGuarantees({ page: 1, size: pageSize })
    
    if (!vendorOptions.data.length && !vendorOptions.loading) {
      props.getVendors()
    }

    if (!companyOptions.data.length && !companyOptions.loading) {
      props.getCompanies()
    }
  }, [])

  return (
    <MainBodyContent headerTitle='Bank Guarantee Report'
      accessoriesHeader={
        <React.Fragment>
          {
            user.isFinance ?
              <div style={{ display: 'flex' }}>
                <CustomButton
                  onClick={() => setShowCreateModal(true) /*props.history.push(bgBuyCreatePath)*/}
                  icon='plus'
                  btnColor='gray'
                  title='Create' />
              </div> : null
          }
        </React.Fragment>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList 
            placeholder='Doc No., Title, Bank Guarantee Number' 
            fetchAPI={props.getBankGuarantees} 
            formSearchName='formSearchBG' 
            filterDate 
            filterStatus 
            hideProject={true}
            bgType='report'
            pageSize={userPageSize}
            showExportButton
          />
          <BGListContainer>
            <ReactTable
              data={Object.keys(listBG).length > 0 ? listBG.data : []}
              columns={columns(vendorOptions.data, companyOptions.data)}
              defaultPageSize={userPageSize}
              noDataText='No bank guarantee data.'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={Object.keys(listBG).length > 0 ? listBG.totalPage : 0}
              currentPage={Object.keys(listBG).length > 0 ? listBG.page : 0}
              onPageChange={(pageIndex) => {
                props.getBankGuarantees({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.getBankGuarantees({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0, 5,10,11].indexOf(Number(rowInfo.original.status)) >= 0) {
                        window.open(bgVendorEditPath(rowInfo.original.id), '_blank')
                      } else {
                        window.open(bgVendorDetailPath(rowInfo.original.id), '_blank')
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </BGListContainer>
        </ProcurementBody>
      </ProcurementContainer>
      {
        showCreateModal ? <CreateBankGuaranteeModal closeForm={() => setShowCreateModal(false)} history={props.history} /> : null
      }
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  const user = state.authen.user || {}
  return ({
    user,
    valueForm: getFormValues('formSearchBG')(state) || {},
    listBG: state.bg.listBankGuarantee.data,
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
  })
}

const mapDispatchToProps = {
  getBankGuarantees,
  getVendors, 
  getCompanies,
}

const contForm = reduxForm({
  form: 'formSearchBG',
  enableReinitialize: true,
})(PurchaseRequisition)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)